import axios from 'axios'
export const getAnalytics = (type, year) => axios.get(`/dashboard/graph/${type}/${year}`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getInvoice = type => axios.get(`/dashboard/${type}/invoice`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getRoadMap = () => axios.get('/dashboard/rfq-completed')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getTimePerformance = () => axios.get('/dashboard/onetime')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getSavings = () => axios.get('/dashboard/savings')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getTotalSpendingYTD = () => axios.get('/dashboard/spending-ytd')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getTodolist = () => axios.get(`/dashboard/todo-list/count`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getTodolistPagination = (currentPage, perPage) => axios.get(`/dashboard/todo-list/${currentPage}/${perPage}`)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const updateIsReadTodo = payload => axios.put('/dashboard/todo-list', payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getNotifications = () => axios.get('/dashboard/notifications/count')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getNotificationsAll = (page) => axios.get(`/dashboard/notifications/page/${page}`)
  .then(res => {
    return res
  })
  .catch((err) => {
    throw err.response
  })

export const updateIsReadNotif = payload => axios.put('/dashboard/notifications/read', payload)
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getCredit = () => axios.get('dashboard/credits')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })

export const getRoadMapCountry = () => axios.get('dashboard/road-map')
  .then(res => res)
  .catch((err) => {
    throw err.response
  })



// WEBPACK FOOTER //
// ./src/api/dashboard.api.js